export default __webpack_public_path__ + "static/media/call-color-icon.72f6b745.svg";